/*
 *   File : list.js
 *   Author : https://evoqins.com
 *   Description : Manage banner page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useEffect, useRef, useState } from "react";
import { CustomTab, EmptyScreen, Loader } from "../../Components/Others";
import { useLocation, useNavigate } from "react-router-dom";
import { SecondaryButton } from "../../Components/Buttons";
import { CustomDataTable } from "../../Components/DataTable";
import { ConfirmModal, ManageBannerModal, ViewBannerModal } from "../../Components/Modal";
import { Modal } from "bootstrap";
import { APIService } from "../../Service";
import { toast } from "react-toastify";

const TAB_TITLES = [
    { id: 1, type: "promotional", label: 'Promotional', tooltip: false },
    { id: 2, type: "services", label: 'Services', tooltip: false }
];


const ROWS_PER_PAGE = 10;

const ManageBanner = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const scrollRef = useRef(null);

    const [selectedTab, setSelectedTab] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);

    const [manageBannerModal, setManageBannerModal] = useState(false);
    const [bannerData, setBannerData] = useState({});
    const [loader, setLoader] = useState(true);
    const [serviceBannerModal, setServiceBannerModal] = useState(false);
    const [bannerId, setBannerId] = useState(null);
    const [editData, setEditData] = useState({});
    const [viewBanner, setViewBanner] = useState(false);
    const [testButtonLoader, setTestButtonLoader] = useState({});


    const [confirmPublishModal, setConfirmPublishMOdal] = useState(false);
    const [publishStatus, setPublishStatus] = useState(false);

    const [modalContent, setModalContent] = useState({ title: "", description: "" });


    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (state?.tab_index) {
            setSelectedTab(state.tab_index);
        } else {
            setSelectedTab(1);
        }
    }, [state]);


    useEffect(() => {
        if (selectedTab !== 0) {
            _getBannerData();
        }
    }, [selectedTab, currentPage]);

    useEffect(() => {
        if (manageBannerModal === true || serviceBannerModal === true) {
            const open_modal = new Modal(document.getElementById('manage-banner-modal'));
            open_modal.show();
        }
    }, [manageBannerModal, serviceBannerModal]);

    useEffect(() => {
        if (viewBanner === true) {
            const open_modal = new Modal(document.getElementById('view-banner-modal'));
            open_modal.show();
        }
    }, [viewBanner]);

    useEffect(() => {
        if (confirmPublishModal === true) {
            const modal = new Modal(document.getElementById('confirm-modal'));
            modal.show();
        }
    }, [confirmPublishModal]);

    // handle tab
    const _handleTab = (tab_id) => {
        navigate("/manage-banner", {
            state: {
                tab_index: tab_id,
            }
        });
        setCurrentPage(1);
    };

    // handle table page change 
    const _handlePagination = (page_num) => {
        setLoader(true);

        setCurrentPage(page_num);
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    };

    const [rowData, setRowData] = useState(null);

    // Service column
    const PROMOTIONAL_COLUMN = [
        {
            name: 'Created on',
            selector: row => row.created_at,
            width: "120px",
            sortable: true,
            format: row => row.created_at,

        },
        {
            name: 'Title',
            selector: row => row.title || "-",
            cell: row => <>{row.title || "-"}</>,
            width: "280px",
            sortable: true,
        },
        {
            name: 'Message',
            cell: (row) => <>{row.description || "-"}</>,
            width: "360px"
        },
        {
            name: 'Status',
            selector: row => row.status ? "Active" : "Non active",
            width: "110px",
        },
        {
            name: '',
            cell: (row) =>
                <span className='cursor-pointer e-text-blue-violet text-decoration-hover-underline e-font-14 e-font-weight-500 line-height-18px'
                    onClick={() => {
                        if (row.status === true) {
                            setBannerId(row.banner_id);
                            setManageBannerModal(true);
                            setEditData(row);
                        } else {
                            setViewBanner(true);
                            setEditData(row);
                        }
                    }}  >
                    {row.status === true ? "Edit" : "View"}
                </span>,
            width: "80px"
        },
        {
            name: '',
            cell: (row) =>
                <span className='cursor-pointer e-text-blue-violet text-decoration-hover-underline e-font-14 e-font-weight-500 line-height-18px'
                    onClick={() => {
                        setConfirmPublishMOdal(true);
                        setRowData(row);

                        setModalContent({
                            title: row.status === true ? "Confirm Un-publish" : "Confirm Re-publish",
                            description: row.status === true ? "Are you sure you want to unpublish this banner?" : "Are you sure you want to republish this banner?"
                        });

                    }}>
                    {row.status === true ? "Un-publish" : "Re-publish"}
                </span>
            ,
            width: "120px"
        },
    ];


    const SERVICE_COLUMN = [
        {
            name: 'Created on',
            selector: row => row.created_at,
            width: "110px",
            sortable: true,
            format: row => row.created_at,
        },
        {
            name: 'Title',
            selector: row => row.title || "-",
            cell: (row) => <>{row.title || "-"}</>,
            width: "280px",
            sortable: true,
        },
        {
            name: 'Message',
            cell: (row) => <>{row.description || "-"}</>,
            width: "330px"
        },
        {
            name: 'Status',
            selector: row => row.status === true ? "Active" : "Non active",
            width: "110px",
            sortable: true,
        },
        {
            name: 'Display days count',
            selector: row => row.days || "-",
            width: "140px",
            sortable: true,
        },
        {
            name: '',
            cell: (row) =>
                <span className='cursor-pointer e-text-blue-violet text-decoration-hover-underline e-font-14 e-font-weight-500 line-height-18px'
                    onClick={() => {
                        if (row.status === true) {
                            setBannerId(row.banner_id);
                            setEditData(row);
                            setServiceBannerModal(true);
                        } else {
                            setViewBanner(true);
                            setEditData(row);
                        }
                    }}>
                    {row.status === true ? "Edit" : "View"}
                </span>,
            width: "80px"
        },
        {
            name: '',
            cell: (row) =>
                <span className='cursor-pointer e-text-blue-violet text-decoration-hover-underline e-font-14 e-font-weight-500 line-height-18px'
                    onClick={() => {
                        setConfirmPublishMOdal(true);
                        setRowData(row);

                        setModalContent({
                            title: row.status === true ? "Confirm Un-publish" : "Confirm Re-publish",
                            description: row.status === true ? "Are you sure you want to unpublish this banner?" : "Are you sure you want to republish this banner?"
                        });

                    }}>
                    {row.status === true ? "Un-publish" : "Re-publish"}
                </span>
            ,
            width: "120px"
        },
    ];

    // API - Get banner list
    const _getBannerData = () => {
        setLoader(true);
        let is_post = true;
        let url = 'banner/list';
        let request = {
            "page_num": currentPage,
            "page_size": ROWS_PER_PAGE,
            "type": selectedTab
        }

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setBannerData(response.data);
            } else {
                setBannerData({})
            }
            setLoader(false);
        })
    };


    // API - Toggle Un publish / Re publish
    const _togglePublish = () => {

        let is_post = true;
        let url = 'banner/activate';
        let request = {
            "banner_id": rowData.banner_id || null
        }

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {

                setPublishStatus(true);
                setModalContent({
                    title: rowData.status === true ? "Confirm Un-publish" : "Confirm Re-publish",
                    description: rowData.status === true ? "Successfully Un-published the banner" : "Successfully Re-published the banner",
                });

            } else {
                setPublishStatus(false);

                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setTestButtonLoader(prev => ({ ...prev, [rowData.banner_id]: false }));
        })
    };


    return (
        <section className='e-section-height pb-5 e-bg-magnolia' >
            <div className='e-bg-lavender padding-52px-lr pt-2 padding-80px-bottom'>
                <h3 className='margin-32px-bottom e-text-chinese-black e-primary-font e-font-24 e-font-weight-600 line-height-24px'>
                    Manage Banners
                </h3>
            </div>

            <div className='padding-52px-lr margin--80px-top'>
                <div ref={scrollRef} className='e-bg-ghost-white border-radius-16  '>
                    <div className='padding-32px-lr padding-32px-top'>
                        <div className='pb-4 d-flex align-items-center justify-content-between pb- gap-16px flex-wrap'>
                            <CustomTab data={TAB_TITLES}
                                selectedTab={selectedTab}
                                handleClick={_handleTab} />


                            <SecondaryButton name={selectedTab === 1 ? "Create promotional banner" : "Create service banner"}
                                // className={downloadLoader ? "w-129px h-42px" : ""}
                                onClick={() => {
                                    if (selectedTab === 1) {
                                        setManageBannerModal(true);
                                    } else {
                                        setServiceBannerModal(true);
                                    }
                                }} />
                        </div>
                    </div>

                    <>
                        {loader ?
                            <Loader className="min-vh-100" />
                            :
                            Object.keys(bannerData).length !== 0 && bannerData.length !== 0 ?
                                <div className='e-data-table-wrapper-default-updated pt- padding-32px-bottom'>
                                    <CustomDataTable columns={selectedTab === 1 ? PROMOTIONAL_COLUMN : SERVICE_COLUMN}
                                        data={bannerData.data}
                                        pagination={true}
                                        paginationPerPage={ROWS_PER_PAGE}
                                        paginationDefaultPage={bannerData.current_page}
                                        paginationTotalRows={bannerData.total_count}
                                        lastPage={bannerData.total_page}
                                        onChangePage={_handlePagination}
                                    />
                                </div>
                                :
                                <EmptyScreen
                                    image={require('../../Assets/Image/NotFound/no-data.png')}
                                    title='No data found'
                                    className="min-vh-100"
                                    description={``}
                                />
                        }
                    </>
                </div>
            </div>

            {manageBannerModal === true &&
                <ManageBannerModal title={bannerId === null ? "Create promotional banner" : "Edit promotional banner"}
                    bannerId={bannerId}
                    data={editData}
                    type={1}
                    handleClose={() => {
                        setTimeout(() => {
                            setManageBannerModal(false);
                            setBannerId(null);
                            setEditData({});
                        }, 200);
                    }}

                    handleSuccess={() => {
                        setTimeout(() => {
                            setManageBannerModal(false);
                            _getBannerData();
                        }, 200);
                    }}
                />
            }

            {serviceBannerModal === true &&
                <ManageBannerModal
                    title={bannerId === null ? "Create service banner" : "Edit service banner"}
                    type={2}
                    data={editData}
                    bannerId={bannerId}
                    handleClose={() => {
                        setTimeout(() => {
                            setServiceBannerModal(false);
                            setBannerId(null);
                            setEditData({});
                        }, 200);
                    }}

                    handleSuccess={() => {
                        setTimeout(() => {
                            setServiceBannerModal(false);
                            _getBannerData();
                        }, 200);
                    }}
                />
            }

            {viewBanner === true &&
                <ViewBannerModal title={selectedTab === 1 ? "View promotional banner" : "Service banner"}
                    type={selectedTab}
                    data={editData}
                    handleClose={() => {
                        setTimeout(() => {
                            setEditData({});
                            setViewBanner(false);
                        }, 200);
                    }} />
            }


            {confirmPublishModal === true &&
                <ConfirmModal title={modalContent.title}
                    description={modalContent.description}
                    status={publishStatus}
                    loader={testButtonLoader[rowData.banner_id]}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirmPublishMOdal(false);
                            setPublishStatus(false);
                            setRowData(null);
                        }, 200);
                    }}
                    handleConfirm={() => {
                        setTestButtonLoader(prev => ({ ...prev, [rowData.banner_id]: true }));

                        _togglePublish();
                    }}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setConfirmPublishMOdal(false);
                            setPublishStatus(false);
                            setRowData(null);
                            _getBannerData();
                            setModalContent({ title: "", description: "" });
                        }, 200);
                    }} />
            }

        </section>
    )
}

export default ManageBanner;